import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorLending = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#F7A600"
      d="M12 3.75a8.21 8.21 0 0 0-4.745 1.5H9.3a.75.75 0 0 1 0 1.5H5.511a.75.75 0 0 1-.823-1.2A9.728 9.728 0 0 1 12 2.25c5.385 0 9.75 4.365 9.75 9.75a.75.75 0 0 1-1.5 0A8.25 8.25 0 0 0 12 3.75Zm.133 5.217a.25.25 0 0 0-.265 0l-3.47 2.169a.75.75 0 0 1-.796-1.272l3.47-2.169a1.75 1.75 0 0 1 1.856 0l3.47 2.169a.75.75 0 0 1-.796 1.272l-3.47-2.169Zm-.265 6.066a.25.25 0 0 0 .264 0l3.47-2.169a.75.75 0 0 1 .796 1.272l-3.47 2.169a1.75 1.75 0 0 1-1.856 0l-3.47-2.169a.75.75 0 1 1 .796-1.272l3.47 2.169Z"
    />
    <path
      fill={getTheme(props["data-theme"])}
      d="M3.75 12a.75.75 0 0 0-1.5 0c0 5.385 4.365 9.75 9.75 9.75a9.733 9.733 0 0 0 7.611-3.656.75.75 0 0 0 .134-.684.75.75 0 0 0-.745-.66h-4a.75.75 0 0 0 0 1.5h2.386A8.25 8.25 0 0 1 3.75 12Z"
    />
  </svg>
);
export default SvgTwoColorLending;
